/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import {
  useStripe,
  useElements,
  PaymentRequestButtonElement,
  Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import BrowserWalletPay from "./BrowserWalletPay";

const stripePromise = loadStripe(WP_STRIPE_PL);

const ApplePay = props => {

  let styleMobile = {
    paymentRequestButton : {
      theme: 'light',
      height: '50px',
    }
  };
  let styleWeb = {
    paymentRequestButton: {
      theme: 'dark',
      height: '60px',
    }
  };
  let styleText = {
    textAlign: props.requestOnPage === "orderDetails" ? "start" : "center",
    margin: '10px'
  };

  const stripe = useStripe();
  const elements = useElements();
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [walletType, setWalletType] = useState(null);

  useEffect(() => {
    if (
      stripe &&
      elements &&
      props.billDetails &&
      !isNaN(props.billDetails.total)
    ) {      
      let totalAmount = props.billDetails && props.billDetails.total && props.billDetails.total * 100;
      const pr = stripe.paymentRequest({
        currency: "usd",
        country: "US",
        requestPayerEmail: false,
        requestPayerName: false,
        total: {
          label: "Jason's Wine & Spirits",
          amount: parseInt(Math.round(totalAmount).toFixed(2))
        }
      });
      pr.canMakePayment().then(result => {
        if (result) {
          setWalletType(result);
          setPaymentRequest(pr);
        }
      });
      pr.on("cancel", function() {
        alert("Wallet Payment Cancelled");
      });
      pr.on("paymentmethod", async (ev) => {
           if (props.requestOnPage === "orderDetails"){
            props.handlePaymentMethodSubmit(true, ev);
           }else{
            props.placeOrder(true, ev);
           }
      });
    }
  }, [stripe, elements, props.billDetails.total]);


  const payAppleWallet = async (ev) => {
    ev.preventDefault();
    if (props.requestOnPage === "orderDetails"){
        paymentRequest.show();
    }else{
      let errors = await props.validateDelivery(true);
      if (errors) {
        return;
      } else {
        paymentRequest.show();
      }
  }
};
  
  return (
    <Elements stripe={stripePromise}>
      {paymentRequest && (
        <div>
          <div style={styleText}>OR</div>
          {(walletType && (walletType.applePay || walletType.googlePay)) && <PaymentRequestButtonElement 
            options = {{
              style: props.requestFrom === "phone" ? styleMobile : styleWeb,
              paymentRequest: paymentRequest
            }}
            onClick={(ev) => payAppleWallet(ev)}
          />}
          {(walletType && !walletType.applePay && !walletType.googlePay) && <BrowserWalletPay 
            onClick={(ev) => payAppleWallet(ev)}
          />}
        </div>
      )}
    </Elements>
  );
};
export default ApplePay;



// WEBPACK FOOTER //
// ./src/components/checkout/ApplePay.js